/* ============
 * Product Type Transformer
 * ============
 *
 * The transformer for the productType.
 */

import Transformer from './transformer';

export default class ProductRecommendationTransformer extends Transformer {

  static fetch(recommendation) {
    return {
      id: recommendation.id,
      name: recommendation.name,
      type: recommendation.type,
    };
  }

  static send(recommendation) {
    return {
      id: recommendation.id,
      name: recommendation.name,
      type: recommendation.type,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productRecommendation.js